
import vue from 'vue'

/**
 * request 설정을 한다
 * @param {*} state
 * @param {Object} obj
 * @param {string} obj.apiName - API 이름
 * @param {Number} obj.call - API 호출 시각 (id 처럼 사용)
 * @param {Object} obj.getters - action에서 받아온 getters
 */
const SET_REQUEST = (state, { apiName, call, getters }) => {
  vue.set(state, apiName, call)
  // 모든 호출이 끝나면 
  if (!getters.isCalling) {
    clearTimeout(state.timerId)
    state.timerId = null
    state.isDelayed = false
  }
}
/**
 * isDelay 설정을 한다
 * @param {*} state
 * @param {boolean} delay - 지연 설정 
 */
const SET_DELAY = (state, delay) => {
  state.isDelayed = delay
}
/**
 * timer 설정을 한다
 * @param {*} state
 * @param {Number} timerId - 타이머 id 
 */
const SET_TIMER = (state, timerId) => {
  state.timerId = timerId
}

export default {
  SET_REQUEST,
  SET_DELAY,
  SET_TIMER
}
